import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import Link from 'react-router/Link';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import Account from 'material-ui/svg-icons/action/account-circle';
import OpenInNew from 'material-ui/svg-icons/action/open-in-new';
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import Help from 'material-ui/svg-icons/action/help';
import runtimeEnv from '@mars/heroku-js-runtime-env';

import NotificationBanner from './NotificationBanner';

import { logoutUser } from '../actions/actions';
import perm from '../modules/auth';

import './Header.css';

class Header extends Component {

  constructor(props) {
    super(props);

    this.state = {
      mainMenuOpen: false,
      aboutDialog: false,
    };
  }

  handleOpenMenu = () => {
    this.setState({
      mainMenuOpen: true,
    });
  }

  handleOnRequestChange = (value) => {
    this.setState({
      mainMenuOpen: value,
    });
  }

  triggerHelp = () => window.open('http://www.sanako.com/help/pronounce-live', '_blank');

  handleLogout(event) {
    event.preventDefault();
    this.props.dispatch(logoutUser());
  }

  render() {
    const env = runtimeEnv();
    const { auth } = this.props;
    if (!auth.isAuthenticated) {
      return <span />;
    }

    perm.setPermissions(auth.user.permissions);
    perm.setRole(auth.user.role);

    let name;
    if (auth.user) {
      name = auth.user.name;
    }

    const style = {

    };

    const iconStyle = {
      color: '#fff',

    };

    const actions = [
      <FlatButton
        label="Close"
        primary
        onTouchTap={() => this.setState({ aboutDialog: false })}
      />,
    ];

    const aboutDialog = (
      <Dialog
        title="About Pronounce Live"
        actions={actions}
        modal={false}
        autoScrollBodyContent={true}
        open={this.state.aboutDialog}
        onRequestClose={() => this.setState({ aboutDialog: false })}
      >
        <p>Sanako Pronounce Live is a true online solution for pronunciation practice, no installations or downloads are needed.</p>

        <p>Pronounce Live requires the Google Chrome browser.</p>
        <p>Build created: { env.REACT_APP_HEROKU_RELEASE_CREATED_AT }</p>
        <p>Build version: { env.REACT_APP_HEROKU_RELEASE_VERSION }</p>
        <h3>About Sanako Corporation</h3>

        <p>Sanako is the global leader in developing language teaching software and services for the educational sector. We have worked closely with our customers for over 50 years towards a single goal: to enable better comprehension, speaking and communication skills for language learners.</p>

        <p>Sanako Corporation is a global organization employing professionals on four continents. Our headquarters is located in Finland. Our network of partners worldwide ensures we are always close to our customers.</p>

        <h3>Contact Us</h3>

      <h4>Personal users</h4>
      <p>If you have any questions, please check our <a target="_blank" href="http://www.sanako.com/help/pronounce-live-faq/">FAQ</a> first.</p>
      <p>If the FAQ doesn't answer your question, you can contact us at <a href="mailto:pronouncelive@sanako.com">pronouncelive@sanako.com</a>.</p>

      <h4>Institutions</h4>

        <p>Pronounce Live is available for institutions also. You can contact us for more information at:</p>

        <p><a href="mailto:pronouncelive@sanako.com">pronouncelive@sanako.com</a></p>

        <p>Our reseller network around the world is ready to serve you. You can find the complete list of Sanako resellers at:</p>

        <p><a href="http://www.sanako.com/resellers/">http://www.sanako.com/resellers/</a></p>

        <p>Don&rsquo;t hesitate to contact us if you cannot find a reseller or you want us to find the most suitable partner for you.</p>

      </Dialog>
      );

    const links = (
      <span className="pronounce-header-user-info">
        <span onClick={ () => this.handleOpenMenu() } className="pronounce-header-user-name">
          {name}
        </span>
        <IconMenu
          open={this.state.mainMenuOpen}
          onRequestChange={this.handleOnRequestChange}
          style={style}
          iconStyle={iconStyle}
          iconButtonElement={<IconButton><ArrowDropDown /></IconButton>}
          anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        >
          <MenuItem primaryText="Use Pronounce Live" containerElement={<Link to="/" />} />
          {perm.can('control-group') && <MenuItem primaryText="Group Settings" containerElement={<Link to="/group-settings" />} />}
          {perm.can('control-group-exercises') && <MenuItem primaryText="Exercises" containerElement={<Link to="/group-settings/exercises" />} />}
          <MenuItem primaryText="Account" containerElement={<Link to="/account" />} />
          {!auth.user.hasGroup && !auth.user.hasActiveSubscription && <MenuItem primaryText="Join Group" containerElement={<Link to="/account/join-group" />} />}
          {!auth.user.hasGroup && <MenuItem primaryText="Subscription" containerElement={<Link to="/account/subscription" />} />}
          <MenuItem primaryText="About" onTouchTap={() => this.setState({ aboutDialog: true })} />
          <MenuItem primaryText="Help" rightIcon={<OpenInNew />} onTouchTap={() => this.triggerHelp() } />
          <MenuItem primaryText="Show welcome screen" onTouchTap={event => this.props.showWelcomeScreen()} />
          <MenuItem primaryText="Log out" onTouchTap={event => this.handleLogout(event)} />
        </IconMenu>

      <IconButton
        onTouchTap={ () => this.triggerHelp() }
        tooltip="Opens external help in a new tab"
        iconStyle={iconStyle}
        >
        <Help />
      </IconButton>
      </span>
      );


    return (
      <div className="pronounce-header">
        <div className="pronounce-header-container">
          <Link className="pronounce-header-logo-image" to="/">
            <img alt="Pronounce Live" src="/logo.png" height="30" />
          </Link>
          <NotificationBanner {...this.props} />
          {links}
          {this.state.aboutDialog && aboutDialog}
        </div>
      </div>
    );
  }

}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js